import {TABLE_LOADING, TABLE_STATE_CHANGE} from "./actions";

const defaultState = {
  sorted: [],
  page: 0,
  pageSize: 10,
  expanded: {},
  resized: [],
  filtered: [],
  data: []
};


export const table = (state = defaultState, action) => {

  switch (action.type) {

    case TABLE_STATE_CHANGE:
      return {
        ...state,
        ...action.stateToChange
      };

    case TABLE_LOADING:
      return {
        ...state,
        loading : action.loading
      };

    default:
      return state;
  }

};